
import { defineComponent } from "vue";
import { usePlugin } from "@/plugins";

export default defineComponent({
  name: "NotFound",
  setup() {
    const { onRouterPush } = usePlugin();
    const goHome = () => {
      onRouterPush({ name: "home" });
    };
    return { goHome };
  },
});
